import 'array-from-polyfill';
import 'nodelist-foreach-polyfill';

import Promise from 'promise-polyfill';
window.Promise = window.Promise || Promise;

import './utils/utils.closest-method-polyfill';

import './components/components.testimonials-carousel';
import './components/components.solutions-explorer';
import './components/components.logo-collection-carousel';
import './components/components.featured-content-carousel';
import './components/components.accordion';
import './components/components.hero-banner-home';
import './components/components.site-navigation';
import './components/components.stat-pullout';
import './components/components.site-search';
import './components/components.gdpr-toggle';
import './components/components.related-content';
import './components/components.scroll-to-form';
import './components/components.llp-and-consent';
import './components/components.lazy-load-images';
import './components/components.contact-form-7';
import './components/components.tabbed-content';
